import React, { useEffect, useState } from "react"
import { Col, Input, Label, Modal, Row, FormGroup } from "reactstrap"
import RoadmapChart from "../RoadmapChart"
import CategoryInfoGanttChart from "components/custom/CategoryInfoGanttChart"

const RoadmapChartModal = ({
  isOpen,
  toggleModal,
  roadmapId,
  roadmapType,
  fyMonth,
  history
}) => {
  return (
    <Modal
      backdrop="static"
      isOpen={isOpen}
      fullscreen={true}
      toggle={() => {
        toggleModal()
      }}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0" id="myModalLabel">
          Roadmap Chart
        </h5>
        <button
          type="button"
          onClick={() => {
            toggleModal()
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <div className="mb-3">
          <RoadmapChart roadmapId={roadmapId} roadmapType={roadmapType} history={history} />
        </div>
      </div>
      <div
        className="modal-footer"
        style={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={toggleModal}
        >
          Close
        </button>
      </div>
    </Modal>
  )
}

export default RoadmapChartModal
